/** Merchant labels for the saved direct study's audience frame. */
import type { ShopifyAudienceMode } from '../types'

const AUDIENCE_FRAME_LABELS: Record<ShopifyAudienceMode, string> = {
  broad_population: 'General shoppers',
  all_customers_overlay: 'Shaped by your customers',
  repeat_customers: 'Your repeat buyers',
  lapsed_customers: 'Your lapsed customers',
  high_value_customers: 'Your higher spenders',
  product_affinity_customers: 'Customers interested in this category',
  custom_merchant_segment: 'Custom audience',
}

/** Label for the merchant-selected audience frame; does not imply a known respondent count. */
export function getAudienceFrameLabel(audienceMode: ShopifyAudienceMode) {
  return AUDIENCE_FRAME_LABELS[audienceMode]
}
